import { render, staticRenderFns } from "./Profil.vue?vue&type=template&id=6e7fd01a&scoped=true"
import script from "./Profil.vue?vue&type=script&lang=js"
export * from "./Profil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7fd01a",
  null
  
)

export default component.exports